// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_cs-a";
export var fulfillmentFormRail = "_cs-9";
export var headerTitleRow = "_cs-c";
export var orderDetailsWrapper = "_cs-7";
export var orderLinkTrigger = "_cs-2";
export var paymentInformationGrid = "_cs-h";
export var paymentSummaryColumn = "_cs-i";
export var shipmentContainer = "_cs-b";
export var shipmentDetailsMainPane = "_cs-8";
export var shipmentNavigationCard = "_cs-5";
export var shipmentNavigationRail = "_cs-3";
export var shipmentNavigationRailHeader = "_cs-4";
export var shipmentSummaryFact = "_cs-e";
export var shipmentSummaryGrid = "_cs-d";
export var shipmentSummaryMetadataRow = "_cs-f";
export var shipmentSummaryTags = "_cs-g";
export var shipmentWorkspace = "_cs-0";
export var shipmentWorkspaceContent = "_cs-6";
export var shipmentWorkspaceHeader = "_cs-1";